import type { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
  hideHeader?: boolean;
}

export function Layout({ children, hideHeader = false }: LayoutProps) {
  return (
    <div className="flex h-full flex-col bg-background safe-top safe-bottom">
      {!hideHeader && (
        <header className="sticky top-0 z-50 border-b border-outline bg-primary px-4 py-3 shadow-sm">
          <div className="flex items-center justify-center">
            <h1 className="text-lg font-semibold text-primary-foreground">TCG Price Lookup</h1>
          </div>
        </header>
      )}

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-background">{children}</main>
    </div>
  );
}
